export default __webpack_public_path__ + "media/images/images/backgrounds/breadcrumb-85cc1ce68536bc263a436ea7e4e60b22.png";